/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Motivation_Form_Motivations_Motivation_LabelInputs */

const en_motivation_form_motivations_motivation_label = /** @type {(inputs: Motivation_Form_Motivations_Motivation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivation`)
};

const de_motivation_form_motivations_motivation_label = /** @type {(inputs: Motivation_Form_Motivations_Motivation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivation`)
};

/**
* | output |
* | --- |
* | "Motivation" |
*
* @param {Motivation_Form_Motivations_Motivation_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const motivation_form_motivations_motivation_label = /** @type {((inputs?: Motivation_Form_Motivations_Motivation_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Motivation_Form_Motivations_Motivation_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_motivation_form_motivations_motivation_label(inputs)
	return en_motivation_form_motivations_motivation_label(inputs)
});